import React, { useState, useContext } from "react";
import { LoginContext } from "../../../contexts/LoginContext";
import { PencilIcon } from "@heroicons/react/solid";
import { updateOngoingProjectDeadline } from "../../../pages/teacher/ongoing-projects/ongoing-project-details/api-handlers";
import routes from "../../../config/routes-config";

const ProjectDetails = ({ project }) => {
  const { user, userAuthStatus } = useContext(LoginContext);

  const handleUpdateDeadline = (event) => {
    const newDeadline = event.target.value;
    const projectDeadline = { id: project.projectID, deadline: newDeadline };

    updateOngoingProjectDeadline(
      routes.teacher.ongoingProjects.updateDeadline,
      user.token,
      projectDeadline
    );
  };

  const [disabled, setDisability] = useState(true);

  const handleDisability = () => {
    setDisability((previousState) => !previousState);
  };

  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-row mt-4">
          <h1 className="text-[#D83636] w-32">Deadline</h1>
          <PencilIcon className="w-6" />
          <input
            type="date"
            onChange={handleUpdateDeadline}
            value={project.deadline}
            disabled={disabled}
            className={disabled ? "bg-gray-300" : "bg-white"}
          />
          <button
            onClick={handleDisability}
            className=" mx-4 text-sm bg-transparent hover:bg-[#777777] text-blue-700 font-semibold hover:text-white px-4 border border-blue-500 hover:border-transparent rounded"
          >
            Update Deadline
          </button>
        </div>
        <div className="flex flex-row mt-4">
          <h1 className="text-[#1C42D5] w-32">Title</h1>
          <div>
            <div className="flex justify-center relative rounded-md shadow-sm ">
              <h2
                type="text"
                name="price"
                id="price"
                className="h-7 focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-12 sm:text-sm border-gray-300 rounded-md"
              >
                Project Hub
              </h2>
              <div className="absolute inset-y-0 right-0 flex items-center"></div>
            </div>
          </div>
        </div>

        <div className="flex flex-row mt-4">
          <h1 className="text-[#1C42D5] w-32">Domain</h1>
          <div className="border-[#B2B7FF] border-2 rounded-2xl px-4">
            <h1 className="text-bg[#555555]">Smart Education</h1>
          </div>
        </div>

        <div className="flex flex-row mt-4">
          <h1 className="text-[#1C42D5] w-32">Tags</h1>
          <div className="flex flex-row flex-wrap">
            <div className="border-[#B2B7FF] border-2 rounded-2xl px-4 mr-2 mb-1">
              <h1 className="text-bg[#555555]">App Development</h1>
            </div>
            <div className="border-[#B2B7FF] border-2 rounded-2xl px-4 mr-2 mb-1">
              <h1 className="text-bg[#555555]">Web Development</h1>
            </div>
            <div className="border-[#B2B7FF] border-2 rounded-2xl px-4 mr-2 mb-1">
              <h1 className="text-bg[#555555]">Machine Learning</h1>
            </div>
          </div>
        </div>

        <div className="flex flex-row mt-4">
          <h1 className="text-[#1C42D5] w-32">Description</h1>
          <div className="rounded-md shadow-sm w-96">
            <div className="mb-3 w-96">
              <textarea
                className="resize-none form-textarea mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full pr-12 border-gray-300 rounded-md"
                rows="3"
                maxLength={140}
                value="A place to host, share and collaborate on your projects with your peers and professors"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectDetails;
